/**
* tailwind plugins was written using extend configuration feature. It was used to give our modal sizes into the existing config.

* ? https://tailwindcss.com/docs/plugins#extending-the-configuration
*/
import plugin from 'tailwindcss/plugin'

export default plugin(
  ({ matchUtilities, theme }) => {
    matchUtilities(
      {
        'modal-size': (value) => ({
          maxWidth: value,
        }),
      },
      { values: theme('modalSize') },
    )
  },
  {
    theme: {
      modalSize: {
        xs: '640px',
        sm: '768px',
        md: '1024px',
        lg: '1280px',
        xl: '15360px',
      },
    },
  },
)
